import { render, staticRenderFns } from "./SendCouponPackage.vue?vue&type=template&id=6dbdd7a0&scoped=true"
import script from "./SendCouponPackage.vue?vue&type=script&lang=js"
export * from "./SendCouponPackage.vue?vue&type=script&lang=js"
import style0 from "./SendCouponPackage.vue?vue&type=style&index=0&id=6dbdd7a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbdd7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbdd7a0')) {
      api.createRecord('6dbdd7a0', component.options)
    } else {
      api.reload('6dbdd7a0', component.options)
    }
    module.hot.accept("./SendCouponPackage.vue?vue&type=template&id=6dbdd7a0&scoped=true", function () {
      api.rerender('6dbdd7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/staffManage/dialogs/SendCouponPackage.vue"
export default component.exports